import { when } from 'mobx';

import type { Campaign, Segments } from '@feathr/blackbox';
import { PinpointEmailBaseCampaign } from '@feathr/blackbox';

/**
 * Shared preSave function for campaign editing.
 * Ensures ephemeral segments are added to the store before campaign save.
 */
export async function ensureEphemeralSegmentsAreSaved(
  newCampaign: Campaign,
  Segments: Segments,
): Promise<void> {
  if (newCampaign instanceof PinpointEmailBaseCampaign) {
    const campaignSegments = newCampaign.get('segments');
    await Promise.all(
      campaignSegments.map(async (s) => {
        if (!s.id) {
          return;
        }
        const campaignSegment = Segments.get(s.id);
        await when(() => !campaignSegment.isPending);
        if (campaignSegment.isEphemeral) {
          await Segments.add(campaignSegment);
        }
      }),
    );
  }
}
